module.exports = __webpack_public_path__ + "static/media/FifteenMinuteRule.fb32f31b.mp3";